'use es6';

import http from 'hub-http/clients/apiClient'; // For upgrading Directory users to HubSpot Partner Agencies

export const provisionPartnerParcels = (portalId, countryCode) => {
  return http.post(`/partnerdb/v1/provisioning/touchless?portalId=${portalId}`, {
    data: {
      countryCode,
      partnerType: 'SALES_SOLUTION'
    }
  });
};
export const isPaidHub = () => {
  return http.get('/iris-read/v1/app?hubField=paidHub').then(payload => payload.hub.paidHub);
};